const shouldTriggersBeShown = ({
  isViewLoaded,
  isDialogVisible,
  customUIVisibility,
  isContextMenuVisible,
  focusedElementId,
  selectedElementId,
  activeCustomTool,
}) =>
  Boolean(
    isViewLoaded &&
      !isDialogVisible &&
      !customUIVisibility &&
      !isContextMenuVisible &&
      !focusedElementId &&
      !selectedElementId &&
      !activeCustomTool
  );

export default shouldTriggersBeShown;
